import React, {useEffect, useState, ReactNode, useMemo} from "react"
import authentication from "@irati/auth"
import Braze from "../services/braze"
import brazeLogger, {BrazeLogger} from "../services/brazeLogger"
import {ActionsContext, NotificationActionContext, NotificationContext, initial} from "./context"
import {brazeAdapter} from "./adapters/brazeAdapter"

interface Props {
  children: ReactNode
  logger?: BrazeLogger
}

export const ContentCardProvider = ({children, logger = brazeLogger}: Props) => {
  const [contentCards, setContentCards] = useState(initial)

  useEffect(() => {
    if (authentication.apps("platform.contentCards") && !authentication.isUserGhost()) {
      setContentCards((oldCards) => brazeAdapter(Braze.getContentCards(), oldCards, logger))
    }
  }, [])

  const actions: ActionsContext = useMemo(
    () => ({
      // Native only
      clearPopup() {},
      showPopup() {},
      refresh: () => {},
      markContentCardsDismissed: () => {},
      // shared
      markContentCardClicked(id: string) {
        logger.log(`card clicked id: ${id}`)
        Braze.markCardAsClicked(id)
      },
      markContentCardsImpression(ids: string[]) {
        logger.log(`cards seen ids: ${ids.join("\n")}`)
        Braze.markCardsAsSeen(ids)
      }
    }),
    []
  )

  return (
    <NotificationContext.Provider value={contentCards}>
      <NotificationActionContext.Provider value={actions}>{children}</NotificationActionContext.Provider>
    </NotificationContext.Provider>
  )
}
